import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { WarehouseServices } from "apis/Services/WarehouseService";
import TransferModal from "pages/warehouse-inventory/transfer-modal";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PlaceIcon from "@mui/icons-material/Place";

import {
  Button,
  Tag,
  Card,
  Empty,
  Skeleton,
  Statistic,
  Modal,
  Table,
  Tooltip,
} from "antd";
import {
  ArrowDownOutlined,
  DatabaseOutlined,
  DollarOutlined,
  ExclamationCircleOutlined,
  FullscreenOutlined,
  PlusOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";
import Text from "components/text";
import { Block } from "@material-ui/icons";
import { ProjectServices } from "apis/Services/ProjectService";
import MaterialsTable from "pages/warehouse-inventory/materials-table";

export default function WarehouseDashboard() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [data, setData] = useState([]);
  const [transferMaterials, setTransferMaterials] = useState([]);
  const [isTransferMaterialsLoading, setIsTransferMaterialsLoading] =
    useState(true);
  const [recentTransfers, setRecentTransfers] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [isTransferVisible, setIsTransferVisible] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [shouldReload, setShouldReload] = useState(false);

  const [isLowStockModalVisible, setIsLowStockModalVisible] = useState(false);
  const [
    isPastDuePurchaseOrdersModalVisible,
    setIsPastDuePurchaseOrdersModalVisible,
  ] = useState(false);
  const [
    isArrivingPurchaseOrdersModalVisible,
    setIsArrivingPurchaseOrdersModalVisible,
  ] = useState(false);
  const [purchaseOrdersPastDueDate, setPurchaseOrdersPastDueDate] = useState(
    [],
  );
  const [purchaseOrdersArrivingNextWeek, setPurchaseOrdersArrivingNextWeek] =
    useState([]);
  const [isPurchaseOrdersArrivingLoading, setIsPurchaseOrdersArrivingLoading] =
    useState(true);

  const [totalItems, setTotalItems] = useState("");
  const [lastMonthItemsIncrease, setLastMonthItemsIncrease] = useState("");

  const [lowStockItems, setLowStockItems] = useState("");
  const [lowStockItemsInfo, setLowStockItemsInfo] = useState("");
  const [lowStockIncreaseSinceYesterday, setLowStockIncreaseSinceYesterday] =
    useState("");

  const [activeJobSites, setActiveJobSites] = useState("");
  const [createdJobSitesLastWeek, setCreatedJobSitesLastWeek] = useState("");

  const [totalValue, setTotalValue] = useState("");
  const [
    inventoryValueLastQuarterIncrease,
    setInventoryValueLastQuarterIncrease,
  ] = useState("");

  const dispatch = useDispatch();
  const tableRef = useRef();

  useEffect(() => {
    getAccessLevel();
  }, []);

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));
        if (parseInt(res?.accessLevel) > 0) {
          getData();
          getUnits();
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    // setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getWarehouseOverview(ReqObj)
      .then((res) => {
        // setData(res);
        setTotalItems(res.totalItems);
        setLowStockItems(res.lowStockItems);
        setLowStockItemsInfo(res.lowStockItemsInfo);
        setTotalValue(res.totalValue);

        setLastMonthItemsIncrease(res.lastMonthItemsIncrease);
        setLowStockIncreaseSinceYesterday(res.lowStockIncreaseSinceYesterday);
        setInventoryValueLastQuarterIncrease(
          res.inventoryValueLastQuarterIncrease,
        );

        setActiveJobSites(res?.activeJobSites);
        setCreatedJobSitesLastWeek(res?.createdJobSitesLastWeek);
        setData(res?.recentItems);
        setRecentTransfers(res?.recentTransfers);
        console.log(res);
        setisLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    setIsTransferMaterialsLoading(true);
    WarehouseServices.getWarehouseItems(ReqObj)
      .then((items) => {
        setTransferMaterials(Array.isArray(items) ? items : []);
      })
      .catch((err) => {
        console.error("Failed to load warehouse materials", err);
        setTransferMaterials([]);
      })
      .finally(() => setIsTransferMaterialsLoading(false));

    setIsPurchaseOrdersArrivingLoading(true);
    WarehouseServices.getPurchaseOrdersInKoncurent(ReqObj)
      .then((res) => {
        setPurchaseOrdersPastDueDate(
          Array.isArray(res?.purchaseOrdersPastDueDate)
            ? res.purchaseOrdersPastDueDate
            : [],
        );
        setPurchaseOrdersArrivingNextWeek(
          Array.isArray(res?.purchaseOrdersArrivingNextWeek)
            ? res.purchaseOrdersArrivingNextWeek
            : [],
        );
      })
      .catch((err) => {
        console.error("Failed to load purchase order dashboard data", err);
        setPurchaseOrdersPastDueDate([]);
        setPurchaseOrdersArrivingNextWeek([]);
      })
      .finally(() => setIsPurchaseOrdersArrivingLoading(false));
    // .finally(() => setisLoading(false));
  }

  function getUnits() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getInventorySettings(ReqObj)
      .then((res) => {
        console.log("Units:", res);
        setCategoryOptions(res.settingsDict.categories);
        setSubcategoryOptions(res.settingsDict.subcategories);
        setLocationsOptions(res.settingsDict.locations);
        setUnitsOptions(res.settingsDict.units);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleTransferModal = (record) => {
    setSelectedItem(record);
    setIsTransferVisible(true);
  };

  const handleAddNew = () => {
    if (tableRef.current) {
      tableRef.current.openAddModal();
    }
  };

  const handleAddTransfer = () => {
    setSelectedItem();
    setIsTransferVisible(true);
  };

  useEffect(() => {
    if (shouldReload) {
      getData();
      setShouldReload(false);
    }
  }, [shouldReload]);

  const statusColors = {
    Pending: "orange",
    "In Transit": "blue",
    Transit: "blue",
    Delivered: "green",
    Cancelled: "red",
  };

  const lowStockColumns = [
    {
      title: "Material",
      dataIndex: "materialName",
      key: "materialName",
    },
    {
      title: "Min Stock",
      dataIndex: "minStock",
      key: "minStock",
    },
    {
      title: "Current Stock",
      dataIndex: "currentStock",
      key: "currentStock",
    },
  ];

  const formatPurchaseOrderDate = (value) => {
    if (!value) {
      return "-";
    }

    const dateValue = String(value).trim();
    const isoDateMatch = dateValue.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);

    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return `${month.padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;
    }

    const formattedDateMatch = dateValue.match(
      /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/,
    );

    if (formattedDateMatch) {
      const [, month, day, year] = formattedDateMatch;
      return `${month.padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;
    }

    return dateValue;
  };

  const purchaseOrderColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (title) => title || "-",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (description) => description || "-",
    },
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      render: (number) => number || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={statusColors[status] || "default"} bordered={false}>
          {status || "-"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "createdAt",
      render: formatPurchaseOrderDate,
    },
    {
      title: "Delivery Date",
      dataIndex: "delivery_date",
      key: "deliveryDate",
      render: formatPurchaseOrderDate,
    },
    {
      title: "Grand Total",
      dataIndex: "grand_total",
      key: "grandTotal",
      align: "right",
      render: (grandTotal) => {
        const numericTotal = Number(grandTotal);

        if (
          grandTotal === null ||
          grandTotal === undefined ||
          grandTotal === ""
        ) {
          return "-";
        }

        return Number.isNaN(numericTotal)
          ? grandTotal
          : new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(numericTotal);
      },
    },
  ];

  return (
    <div className="bg-white p-4 rounded-3 d-flex justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }}>
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Warehouse Dashboard</h3>
              <p className="opacity-75 mt-2 p-0">
                Manage your construction materials and track inventory across
                job sites
              </p>
            </div>
          </div>

          <div className=" d-flex flex-wrap gap-3 justify-content-start ">
            <Card
              style={{ minWidth: "250px" }}
              className="bg-light bg-opacity-75"
            >
              <div className="d-flex flex-column align-items-start gap-2">
                <div className="d-flex align-items-center gap-3">
                  <DatabaseOutlined
                    style={{ fontSize: 28, color: "#1890ff" }}
                  />
                  <div className=" d-flex flex-column gap-0">
                    <span className=" text-muted">Total Material</span>
                    <p className=" fs-5 fw-bold m-0 p-0">{totalItems}</p>
                  </div>
                </div>

                <div className="d-flex flex-column gap-0">
                  <strong
                    className={`d-flex align-items-center gap-1 ${
                      lastMonthItemsIncrease > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {lastMonthItemsIncrease > 0 ? (
                      <>
                        <TrendingUpIcon /> +
                      </>
                    ) : (
                      <TrendingDownIcon />
                    )}
                    {lastMonthItemsIncrease}%
                  </strong>
                  <small className="text-muted">from last month</small>
                </div>
              </div>
            </Card>

            <Tooltip
              title={lowStockItemsInfo.length > 0 ? "View Low Stock Items" : ""}
            >
              <Card
                style={{ minWidth: "250px", cursor: "pointer" }}
                className="bg-light bg-opacity-75"
                onClick={() => setIsLowStockModalVisible(true)}
              >
                <div className="d-flex flex-column align-items-start gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <WarningOutlined
                      style={{ fontSize: 28, color: "orange" }}
                    />

                    <div className=" d-flex flex-column gap-0">
                      <span className=" text-muted">Low Stock Items</span>
                      <p className=" fs-5 fw-bold m-0 p-0">{lowStockItems}</p>
                    </div>
                  </div>

                  <div className="d-flex gap-1">
                    <strong
                      className={`d-flex align-items-center gap-1 ${
                        lowStockIncreaseSinceYesterday < 0
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {lowStockIncreaseSinceYesterday > 0 ? "+" : "-"}
                      {lowStockIncreaseSinceYesterday}
                    </strong>
                    <span className="text-muted">since yesterday</span>
                  </div>
                </div>
              </Card>
            </Tooltip>

            <Tooltip
              title={
                !isPurchaseOrdersArrivingLoading &&
                purchaseOrdersPastDueDate.length > 0
                  ? "View Past Due Purchase Orders"
                  : ""
              }
            >
              <Card
                style={{
                  minWidth: "250px",
                  cursor: isPurchaseOrdersArrivingLoading
                    ? "default"
                    : "pointer",
                }}
                className="bg-light bg-opacity-75"
                onClick={() => {
                  if (!isPurchaseOrdersArrivingLoading) {
                    setIsPastDuePurchaseOrdersModalVisible(true);
                  }
                }}
              >
                <div className="d-flex flex-column align-items-start gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <ExclamationCircleOutlined
                      style={{ fontSize: 28, color: "#cf1322" }}
                    />
                    <div className="d-flex flex-column gap-0">
                      <span className="text-muted">
                        Past Due Purchase Orders
                      </span>
                      <p className="fs-5 fw-bold m-0 p-0">
                        {isPurchaseOrdersArrivingLoading ? (
                          <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 24, height: 20 }}
                          />
                        ) : (
                          purchaseOrdersPastDueDate.length
                        )}
                      </p>
                    </div>
                  </div>
                  <small className="text-muted">past delivery date</small>
                </div>
              </Card>
            </Tooltip>

            <Tooltip
              title={
                !isPurchaseOrdersArrivingLoading &&
                purchaseOrdersArrivingNextWeek.length > 0
                  ? "View Purchase Orders Arriving in the Next 7 Days"
                  : ""
              }
            >
              <Card
                style={{
                  minWidth: "250px",
                  cursor: isPurchaseOrdersArrivingLoading
                    ? "default"
                    : "pointer",
                }}
                className="bg-light bg-opacity-75"
                onClick={() => {
                  if (!isPurchaseOrdersArrivingLoading) {
                    setIsArrivingPurchaseOrdersModalVisible(true);
                  }
                }}
              >
                <div className="d-flex flex-column align-items-start gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <LocalShippingOutlinedIcon
                      style={{ fontSize: 30, color: "#1677ff" }}
                    />
                    <div className="d-flex flex-column gap-0">
                      <span className="text-muted">
                        Purchase Orders Arriving
                      </span>
                      <p className="fs-5 fw-bold m-0 p-0">
                        {isPurchaseOrdersArrivingLoading ? (
                          <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 24, height: 20 }}
                          />
                        ) : (
                          purchaseOrdersArrivingNextWeek.length
                        )}
                      </p>
                    </div>
                  </div>
                  <small className="text-muted">in the next 7 days</small>
                </div>
              </Card>
            </Tooltip>

            <Card
              style={{ minWidth: "250px" }}
              className="bg-light bg-opacity-75"
            >
              <div className="d-flex flex-column align-items-start gap-2">
                <div className="d-flex align-items-center gap-3">
                  <PlaceIcon style={{ fontSize: 32, color: "#DC143C" }} />
                  <div className=" d-flex flex-column gap-0">
                    <span className=" text-muted">Active Job Sites</span>
                    <p className=" fs-5 fw-bold m-0 p-0">{activeJobSites}</p>
                  </div>
                </div>

                <div className="d-flex gap-1 ">
                  <strong
                    className={`d-flex align-items-center gap-1 ${
                      createdJobSitesLastWeek > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {createdJobSitesLastWeek} new{" "}
                  </strong>
                  <span className="text-muted"> this week</span>
                </div>
              </div>
            </Card>

            <Card
              style={{ minWidth: "250px" }}
              className="bg-light bg-opacity-75"
            >
              <div className="d-flex flex-column align-items-start gap-2">
                <div className="d-flex align-items-center gap-3">
                  <AttachMoneyIcon style={{ fontSize: 32, color: "green" }} />
                  <div className=" d-flex flex-column gap-0">
                    <span className=" text-muted">Inventory Value</span>
                    <p className=" fs-5 fw-bold m-0 p-0">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(totalValue)}
                    </p>
                  </div>
                </div>

                <div className="d-flex flex-column gap-0">
                  <strong
                    className={`d-flex align-items-center gap-1 ${
                      inventoryValueLastQuarterIncrease > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {inventoryValueLastQuarterIncrease > 0 ? (
                      <>
                        <TrendingUpIcon /> +
                      </>
                    ) : (
                      <>
                        <TrendingDownIcon />
                      </>
                    )}
                    {inventoryValueLastQuarterIncrease}%
                  </strong>
                  <small className="text-muted">vs last quarter</small>
                </div>
              </div>
            </Card>
          </div>
          <div className="row mt-2">
            {accessLevel > 1 && (
              <div className="d-flex justify-content-start align-items-center my-4 gap-2">
                <Button type="primary" onClick={handleAddNew} size="large">
                  <PlusOutlined /> Add Material
                </Button>
                <Button
                  onClick={handleAddTransfer}
                  size="large"
                  loading={isTransferMaterialsLoading}
                  disabled={isTransferMaterialsLoading}
                >
                  <LocalShippingOutlinedIcon
                    className=" opacity-75"
                    style={{ fontSize: "1rem" }}
                  />
                  New Transfer
                </Button>

                {/* <Button>Export Report</Button> */}
              </div>
            )}

            {/* Show Empty component when no data */}
            {data.length === 0 ? (
              <div className="d-flex justify-content-center w-100 my-5">
                <Empty />
              </div>
            ) : (
              // Show project cards when data is available
              <>
                <div className="row">
                  <h6 className=" fw-bold mb-3 mt-1">Recent Materials</h6>

                  <MaterialsTable
                    ref={tableRef}
                    data={data}
                    categoryOptions={categoryOptions}
                    subcategoryOptions={subcategoryOptions}
                    locationsOptions={locationsOptions}
                    unitsOptions={unitsOptions}
                    onDataUpdate={getData}
                    showTransferModal={handleTransferModal}
                    searchText={searchText}
                    loading={isLoading}
                    showActions={true}
                    showPagination={false}
                    showAllocationColumns={false}
                    accessLevel={accessLevel}
                  />
                </div>

                <div className="row">
                  <h6 className=" fw-bold mt-5 mb-3">Recent Transfers</h6>
                  <div className=" d-flex flex-wrap gap-2 justify-content-start align-items-center">
                    {recentTransfers.map((item) => (
                      <Card
                        className="bg-light bg-opacity-50"
                        key={item.transferID}
                      >
                        <div className=" d-flex flex-wrap gap-3 justify-content-start justify-content-md-between align-items-center">
                          <div className="">
                            <LocalShippingOutlinedIcon
                              className=" opacity-75 "
                              style={{ fontSize: "1.5rem" }}
                            />
                          </div>
                          <div className=" d-flex flex-column gap-0">
                            <div className=" m-0 p-0">
                              <strong className=" m-0 p-0">
                                Transfer #{item.transferID}
                              </strong>
                            </div>
                            <div className=" d-flex flex-wrap gap-1 justify-content-start align-items-center m-0 p-0">
                              <small className=" m-0 p-0">
                                {item.fromLocation}
                              </small>
                              <ArrowRightAltIcon className=" opacity-75 lh-base" />
                              <small className=" m-0 p-0">
                                {item.toLocation}
                              </small>
                            </div>
                            <div className=" m-0 p-0">
                              {" "}
                              <small className=" m-0 p-0">
                                {item.createdAt.split(" ")[0]}
                              </small>{" "}
                            </div>
                          </div>
                          <div>
                            <Tag
                              color={
                                statusColors[item.currentStatus] || "default"
                              }
                              bordered={false}
                              className="rounded-5 fw-bold"
                            >
                              {item.currentStatus}
                            </Tag>
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <Modal
        title="Low Stock Items"
        open={isLowStockModalVisible}
        onCancel={() => setIsLowStockModalVisible(false)}
        footer={null}
        centered
        width={600}
      >
        <Table
          dataSource={lowStockItemsInfo}
          columns={lowStockColumns}
          pagination={false}
          rowKey={(row) => row.materialName}
        />
      </Modal>

      <Modal
        title="Past Due Purchase Orders"
        open={isPastDuePurchaseOrdersModalVisible}
        onCancel={() => setIsPastDuePurchaseOrdersModalVisible(false)}
        footer={null}
        centered
        width={1100}
      >
        <Table
          dataSource={purchaseOrdersPastDueDate}
          columns={purchaseOrderColumns}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey={(purchaseOrder, index) =>
            purchaseOrder.purchaseOrderID || purchaseOrder.id || index
          }
        />
      </Modal>

      <Modal
        title="Purchase Orders Arriving in the Next 7 Days"
        open={isArrivingPurchaseOrdersModalVisible}
        onCancel={() => setIsArrivingPurchaseOrdersModalVisible(false)}
        footer={null}
        centered
        width={1100}
      >
        <Table
          dataSource={purchaseOrdersArrivingNextWeek}
          columns={purchaseOrderColumns}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey={(purchaseOrder, index) =>
            purchaseOrder.purchaseOrderID || purchaseOrder.id || index
          }
        />
      </Modal>

      <TransferModal
        isTransferVisible={isTransferVisible}
        setIsTransferVisible={setIsTransferVisible}
        record={selectedItem}
        materialsOptions={transferMaterials}
        setShouldReload={setShouldReload}
      />
    </div>
  );
}
